import { Module } from 'vuex';
import { FromAddressListState } from './types';
import { RootState } from '../../types';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: FromAddressListState = {
    fromAddressLists: undefined,
    create: {
        isProcessing: false,
        isCreated: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    show: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
};

const namespaced: boolean = true;

export const fromAddressList: Module<FromAddressListState, RootState> = {
    namespaced,
    state,
    actions,
    mutations,
};
